import Layout from 'layout';
import { ExtendGridBox } from 'styles/integrations';
import SideBar from 'components/marketplace/sideBar';
import Content from 'components/marketplace/content';
import Banner from 'components/marketplace/banner';
import { frontmatter } from 'data/marketplace/integrations';
import arrow from 'img/ui/arrow_black.svg';
import OwnAppSection from 'components/marketplace/ownAppSection';

const Analytics = () => {
  const [mostPopularCard] = frontmatter.items.filter((item) => item.title === 'Google Analytics');
  return (
    <Layout
      metaTitle="Analytics | Integrations"
      canonical="/integrations/analytics/"
      metaDescription="Connect qualitative and quantitative analytics for even more context."
    >
      <div className="container">
        <ExtendGridBox>
          <div className="breadcrumbs">
            <p>
              <a href="/integrations/">Integrations</a>
            </p>
            <img src={arrow} alt="arrow" title="Arrow" />
            <p>
              <a href="/integrations/analytics/">
                <strong>Analytics</strong>
              </a>
            </p>
          </div>
          <SideBar activeCategory="Analytics" underlineColor="#F8D047" />
          <Content activeCategory="Analytics" hideTitle>
            <Banner
              activeCategory="Analytics"
              card={mostPopularCard}
              text="Connect qualitative and quantitative analytics for even more context."
              underlineColor="#F8D047"
            />
          </Content>
        </ExtendGridBox>
        <OwnAppSection />
      </div>
    </Layout>
  );
};

export default Analytics;
